module.exports = __webpack_public_path__ + "img/shopGuide_2b_kr_2.5c81da52.jpg";